<template>
  <section class="programmirovanie-seo v2-container-small">
    <h2>Почему стоит заняться <br> <b>программированием</b> с детства?</h2>

    <div class="programmirovanie-seo__text">
      <h6>
        Мир стремительно меняется, и технологии играют в нем все более важную роль.
        Вот почему ребенку стоит начать обучаться программированию уже сейчас:
      </h6>
      <ul>
        <li>
          <span>
            <b>Развивает логическое мышление и креативность:</b> программирование учит ребенка
            анализировать информацию, решать проблемы,
            строить алгоритмы и находить оптимальные решения.
          </span>
        </li>
        <li>
          <span>
            <b>Открывает новые горизонты:</b> в будущем знание программирования
            будет востребовано во многих профессиях.
          </span>
        </li>
        <li>
          <span>
            <b>Учит работать в команде:</b> наши курсы по программированию предполагают командную
            работу, где дети учатся общаться, делиться идеями и работать над общим проектом.
          </span>
        </li>
        <li>
          <span>
            <b>Повышает самооценку:</b> создавая программы, ребенок ощущает радость от своих
            достижений и чувствует уверенность в своих силах.
          </span>
        </li>
        <li>
          <span>
            <b>Дает возможность самовыражения:</b> программирование – это творческий процесс,
            позволяющий воплощать свои идеи в жизнь.
          </span>
        </li>
        <li>
          <span>
            <b>Развивает  стрессоустойчивость:</b> решение задач по программированию учит ребенка
            находить выход из сложных ситуаций и не сдаваться при возникновении трудностей.
          </span>
        </li>
        <li>
          <span>
            <b>Открывается путь, чтобы заниматься любимым делом:</b> программирование – это
            динамичная и увлекательная сфера с возможностью  работы в различных отраслях.
            <br>
            <br>
            Помните, что обучение программированию не должно быть тяжелым и скучным. В нашей школе
            много интересных и увлекательных  программ, которые помогут ребенку погрузиться
            в мир IT и открыть для себя новые возможности.
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProgrammirovanieSeo',
};
</script>

<style scoped lang="scss">

.programmirovanie-seo {
  padding: 60px;
  //background-color: $white-color;
  background-image: url("/v2/catalog/programmirovanie/seo-bg.svg");
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;

  @include media-down(laptop) {
    padding: 40px 32px;
  }

  @include media-down(tablet) {
    padding-inline: 16px;
    background-image: url("/v2/catalog/programmirovanie/seo-bg-mob.svg");
  }

  h2 {
    margin-bottom: 18px;
    position: relative;

    font-weight: 700;
    font-size: 45px;
    line-height: 1;
    letter-spacing: -1.35px;
    text-transform: uppercase;
    color: $black;

    @include media-down(tablet) {
      max-width: 336px;
      margin-bottom: 32px;

      font-size: 30px;
      line-height: 110%;
    }

    &::before {
      content: '';
      height: 43px;
      width: 525px;
      position: absolute;
      left: -8px;
      top: 46px;
      background-color: $blue-dark;

      @include media-down(tablet) {
        width: calc(100% + 7px);
        height: 34px;
        left: -5 px;
        top: 65px;
      }
    }

    b {
      color: $white-color;
      position: relative;
    }
  }

  .programmirovanie-seo__text {
    &:not(:last-of-type) {
      margin-bottom: 32px;
    }

    h6 {
      margin-bottom: 16px;

      font-weight: 500;
      font-size: 24px;
      line-height: 130%;
      color: $black;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 8px;

      li {
        font-size: 18px;
        line-height: 122%;
        color: $black;
        display: flex;
        gap: 8px;

        &::before {
          content: '';
          flex-shrink: 0;
          width: 16px;
          height: 24px;
          background-image: url("/v2/catalog/programmirovanie/circle.svg");
          background-repeat: no-repeat;
          background-position: right center;
        }

        b {
          font-weight: 700;
        }
      }
    }
  }
}

</style>
